import React, { useEffect, useRef } from 'react';
import { trackAdActivity } from '../lib/adTracker';

interface AdsterraBannerProps {
  className?: string;
  showLabel?: boolean;
}

const AdsterraBanner: React.FC<AdsterraBannerProps> = ({ className = '', showLabel = true }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Clear previous contents
    container.innerHTML = '';

    // Create an isolated iframe for this ad slot
    const iframe = document.createElement('iframe');
    iframe.width = '300';
    iframe.height = '250';
    iframe.style.width = '300px';
    iframe.style.height = '250px';
    iframe.style.border = '0';
    iframe.style.overflow = 'hidden';
    iframe.scrolling = 'no';
    iframe.setAttribute('title', 'Advertisement');
    iframe.setAttribute('loading', 'eager');

    const htmlContent = `<!DOCTYPE html>
<html>
  <head>
    <meta charset="utf-8">
    <meta name="referrer" content="always">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <base target="_blank">
    <style>
      * { box-sizing: border-box; margin: 0; padding: 0; }
      html, body {
        width: 300px;
        height: 250px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: transparent;
      }
    </style>
  </head>
  <body>
    <script type="text/javascript">
      atOptions = {
        'key' : 'b345b0953092d7e6c2b000832d532619',
        'format' : 'iframe',
        'height' : 250,
        'width' : 300,
        'params' : {}
      };
    </script>
    <script type="text/javascript" src="https://www.highrevenueformat.com/b345b0953092d7e6c2b000832d532619/invoke.js"></script>
  </body>
</html>`;

    container.appendChild(iframe);

    // Write to the iframe document to inherit the parent domain and referrer
    try {
      const doc = iframe.contentWindow?.document || iframe.contentDocument;
      if (doc) {
        doc.open();
        doc.write(htmlContent);
        doc.close();
      } else {
        iframe.srcdoc = htmlContent;
      }
    } catch {
      iframe.srcdoc = htmlContent;
    }

    trackAdActivity({
      eventType: 'impression',
      placement: 'adsterra_banner_300x250',
    });

    return () => {
      if (container) {
        container.innerHTML = '';
      }
    };
  }, []);

  return (
    <div className={`adsterra-banner-wrapper flex flex-col items-center justify-center my-3 ${className}`}>
      {showLabel && (
        <div className="flex items-center gap-1.5 mb-2 opacity-60 select-none">
          <span className="text-[9px] font-black tracking-widest uppercase text-slate-400 dark:text-slate-500">Sponsored</span>
        </div>
      )}
      <div 
        ref={containerRef} 
        className="w-[300px] h-[250px] min-w-[300px] min-h-[250px] bg-slate-50/80 dark:bg-slate-900/60 rounded-2xl overflow-hidden shadow-sm flex items-center justify-center border border-slate-200/60 dark:border-slate-800/80"
      />
    </div>
  );
};

export default AdsterraBanner;

